/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, IconButton, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PdfPreviewPanel from './PdfPreviewPanel';

const PdfViewerDialogV2 = ({ open, onClose, file, title, fileName }) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth={false}
    sx={{ zIndex: (theme) => theme.zIndex.modal + 4 }}
    slotProps={{
      paper: {
        sx: {
          width: 'min(96vw, 900px)',
          maxWidth: '96vw',
          height: 'min(92vh, 860px)',
          maxHeight: '92vh',
          bgcolor: 'common.black',
          backgroundImage: 'none',
          overflow: 'hidden',
          borderRadius: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      },
    }}
  >
    <Box sx={{ position: 'absolute', top: 12, right: 12, zIndex: 3 }}>
      <Tooltip title="Fechar (Esc)">
        <IconButton
          onClick={onClose}
          size="small"
          aria-label="Fechar"
          sx={{
            color: 'common.white',
            bgcolor: (theme) => alpha(theme.palette.common.white, 0.12),
            '&:hover': {
              bgcolor: (theme) => alpha(theme.palette.common.white, 0.22),
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
    <Box sx={{ flex: 1, minHeight: 0 }}>
      {open ? (
        <PdfPreviewPanel
          file={file}
          title={title}
          fileName={fileName || title}
        />
      ) : null}
    </Box>
  </Dialog>
);

PdfViewerDialogV2.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  file: PropTypes.any,
  title: PropTypes.string,
  fileName: PropTypes.string,
};

PdfViewerDialogV2.defaultProps = {
  file: null,
  title: '',
  fileName: '',
};

export default PdfViewerDialogV2;
